const MODULE_BY_SEGMENT: Record<string, string> = {
  inicio: 'home',
  cadastros: 'registrations',
  vendas: 'sales',
  suprimentos: 'supply',
  financas: 'finance',
  relatorios: 'reports',
  preferencias: 'preferences',
  'espaco-contador': 'accountant-space',
  'espaco-gestor': 'manager-space',
  notificacao: 'notifications',
  arquivos: 'files',
  suporte: 'support',
};

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const NUMERIC_SEGMENT_RE = /\/\d+(?=\/|$)/g;

export const deriveScreenContext = (pathname: string): { module: string; screen: string } => {
  const segments = pathname.split('/').filter(Boolean);
  const [first, second] = segments;

  const module =
    first === 'cadastros' && second === 'catalogo' ? 'catalog' : (MODULE_BY_SEGMENT[first ?? ''] ?? first ?? 'home');

  const screen = segments.join('/').replace(UUID_RE, ':id').replace(NUMERIC_SEGMENT_RE, '/:id');

  return { module, screen };
};
